<template>
  <clouded-glass class="main">
    <div :class="form.layout === 1 ? 'padding-top-20':'padding-top-10'" slot="content"
         style="overflow:auto;height: 100%">
      <div :key="index" class="margin-top-10" v-for="(item,index) in formData">
        <!--名称-->
        <el-row :class="form.layout === 1 ? 'margin-bottom-20':'margin-bottom-10'" class="text-center font-weight-bold"
                style="font-size: 1.1rem;min-height: 24px;">{{
            item.name
          }}
        </el-row>
        <!--测点-->
        <div style="padding-left: 30px">
          <el-row :key="pointItem.deviceId" class="margin-top-10" v-for="pointItem in item.pointList">
            <span v-if="pointItem.pointId">
            <img :width="22" src="../../../assets/images/pointIcon/CO2.png">
              <span style="margin-left: 10px;"><span class="text-blueGrey">{{
                  pointItem.pointName
                }}</span>：20{{ pointItem.unit }}</span>
            </span>
          </el-row>
        </div>
        <!--曲线-->
        <el-row :class="form.layout === 1 ? 'twoLine':'oneLine'" v-if="item.lineData && item.lineData.data.length > 0">
          <dynamic-line-chart :data="item.lineData" :extendData="extendData" ref="lineChart"
                              style="height: 100%;"></dynamic-line-chart>
        </el-row>
      </div>
    </div>
  </clouded-glass>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import DynamicLineChart from "@/components/echarts/DynamicLineChart";

export default {
  name: "pointViewDesign",
  components: {CloudedGlass, DynamicLineChart},
  props: ['form'],
  data() {
    return {
      extendData: null,
      formData: [],
    }
  },
  watch: {
    form: {
      handler(newV) {
        if (newV.layout) {
          this.initData()
        }
      },
      deep: true
    },
    formData: {
      handler(newV) {
        this.$emit('getFormData', newV)
      },
      deep: true
    },
  },
  methods: {
    initData() {
      this.formData = []
      const pointList = this.form.pointList.filter(item => item.pointId)
      if (this.form.layout === 1) {
        const curveDisplays = pointList.filter(item => item.curveDisplay)
        //曲线合并指标
        this.formData.push(this.form)
        let data = []
        const that = this
        if (pointList.length > 0) {
          pointList.forEach((item, index) => {
            if (item.curveDisplay) {
              let oneLineData = {}
              oneLineData.id = item.pointId;
              oneLineData.deviceId = item.deviceId;
              oneLineData.name = item.pointName;
              oneLineData.unit = item.unit;
              oneLineData.value = [4 * (index + 1) + 2, 6 * (index + 1) / 2, 5 * (index + 1), 7 * (index + 1), 6 * (index + 1)]
              data.push(oneLineData)
            } else if (!item.curveDisplay && this.formData[0].lineData && this.formData[0].lineData.data.length > 0) {
              that.formData[0].lineData.data.forEach((oneLineData, lineIndex) => {
                if (oneLineData.id === item.pointId) {
                  const lineData = this._.cloneDeep(that.formData[0].lineData.data)
                  lineData.splice(lineIndex, 1)
                  that.formData[0].lineData.data = lineData
                }
              })
            }
          })
        }
        //没有曲线显示
        if (curveDisplays.length < 1 && this.formData[0].lineData && this.formData[0].lineData.data.length > 0) {
          delete this.formData[0].lineData
        }
        if (data.length > 0) {
          let lineData = {}
          lineData.time = ["05:21", "05:30", "05:39", "05:45", "05:52"];
          lineData.data = data
          this.formData[0].lineData = lineData
        }
        this.$set(this.formData[0], 'pointList', this.form.pointList)
      } else {
        //曲线跟随指标
        pointList.forEach((item, index) => {
          const formData = {}
          formData.layout = this.form.layout;
          formData.name = item.name;
          formData.pointList = [item];
          if (item.curveDisplay) {
            formData.lineData = {
              time: ["05:21", "05:30", "05:39", "05:45", "05:52"],
              data: [{
                id: item.pointId,
                deviceId: item.deviceId,
                name: item.pointName,
                unit: item.unit,
                value: [4 * (index + 1) + 2, 6 * (index + 1) / 2, 5 * (index + 1) + 5, 2 * (index + 1), 6 * (index + 1)],
                color: index % 2 ? '#ECBB18' : '#07E6F8'
              }]
            }
          }
          this.formData.push(formData)
        })
      }
    },
  }
}
</script>

<style scoped>
.main {
  width: 240px;
  height: 400px;
  margin: 20px auto 0;
  background: rgba(0, 0, 0, 0);
  padding-bottom: 10px;
}

.oneLine {
  height: 120px;
  padding: 0 10px;
}

.twoLine {
  height: 200px;
  padding: 0 10px;
}
</style>
